export default __webpack_public_path__ + "static/ssocase1-7c123c5446744e26188dd1eac304e9cd.png";